<div class="leader-info">
  <a [uiSref]="'profile.about'" [uiParams]="{profileId: user.slug}">
    <ut-avatar-badges [user]="user" size="default"></ut-avatar-badges>
  </a>
  <h5>
    <a [uiSref]="'profile.about'" [uiParams]="{profileId: user.slug}">{{user.name}}</a>
    <ut-dynamic-tooltip [user]="user" tooltipType="user">
      <span tabindex="0"
        class="fa fa-info-circle"
        role="button"
      [attr.aria-label]="'Open ' + user.name + ' tooltip'"></span>
    </ut-dynamic-tooltip>
  </h5>
</div>
<div class="leaderboard-points">{{user.points}}</div>
<div class="leaderboard-follow">
  @if (user.current_user_permissions['follow']) {
    <ut-community-follow-btn [user]="user"></ut-community-follow-btn>
  }
</div>
@if (!user.current_user_permissions['follow']) {
  <div class="cus-checkbox-follow"></div>
}
<div class="leaderboard-badge">
  @for (badge of user.badges; track badge) {
    <img
      [attr.title]="getBadgeTitle(badge.badge_type)"
      [src]="'/utest-static/assets/images/badges/' + getBadgeIcon(badge.badge_type)">
    }
  </div>
